'use strict';

/**
 * @name log
 */
exports.mge = require('./mge.js');



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/log/index.js
// module id = 601
// module chunks = 0